import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/AuthStore';

export default function PublicRoute({ children }) {
  const { isAuthenticated, user } = useAuthStore();

  if (isAuthenticated && user) {
    // Role-based redirect for authenticated users
    if (user.role === 'superAdmin') {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/comms" replace />;
    }
  }

  return children;
}
